var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3241_265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5844 11.2089C16.3687 11.1422 17.1531 11.0844 17.9374 10.9954C18.1506 10.9732 18.3637 10.8753 18.5683 10.7863C19.3569 10.4437 19.7449 9.80757 19.7747 8.93116C19.8045 8.06365 19.4209 7.44526 18.6962 7.04487C18.1463 6.73791 17.5538 6.59555 16.9357 6.55551C16.454 6.52437 16.2707 6.34641 16.211 5.8526C16.0192 4.33556 15.4224 3.05431 14.2117 2.14231C12.2167 0.638619 8.75533 0.8922 7.47649 3.97076C7.23777 4.5491 6.9479 4.79379 6.3639 4.84717C5.60512 4.91835 4.89323 5.19418 4.27512 5.6791C2.80019 6.84468 2.84708 9.22033 4.36038 10.3325C5.18736 10.942 6.12092 11.1333 7.10562 11.1422C7.77062 11.1467 8.43562 11.1422 9.10062 11.1422C9.43738 11.1422 9.69315 11.3824 9.71446 11.7072C9.73578 12.0275 9.50985 12.3612 9.19014 12.3612C7.85588 12.3612 6.50457 12.5213 5.19589 12.1031C3.77637 11.6538 2.68935 10.7952 2.21192 9.27372C1.54266 7.1294 2.49753 4.98953 4.52662 4.09978C5.02111 3.88179 5.55396 3.75277 6.07829 3.61931C6.25733 3.57482 6.34258 3.49919 6.42357 3.33458C7.22925 1.6218 8.51661 0.536297 10.324 0.131458C13.2696 -0.531412 16.3176 1.37712 17.1275 4.40229C17.2085 4.70481 17.2 5.09186 17.3833 5.2876C17.5538 5.47 17.9289 5.43886 18.2102 5.51894C19.2291 5.81256 20.0987 6.31972 20.623 7.3296C21.5438 9.09576 20.7125 11.2846 18.8411 12.0142C18.1932 12.2678 17.5197 12.3701 16.8334 12.379C15.8742 12.3923 14.9151 12.3834 13.956 12.379C13.5254 12.379 13.2696 12.1343 13.2739 11.7428C13.2782 11.3691 13.5297 11.1467 13.956 11.1422C14.4973 11.1422 15.0387 11.1422 15.5801 11.1422C15.5801 11.16 15.5801 11.1822 15.5844 11.2V11.2089Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9171 15.9238C10.9171 15.8328 10.9171 15.7419 10.9171 15.651C10.9171 13.151 10.9171 10.6555 10.9171 8.15546C10.9171 7.73727 11.1167 7.46454 11.437 7.43726C11.8196 7.40545 12.0733 7.67818 12.0733 8.13727C12.0733 9.51002 12.0733 10.8828 12.0733 12.2555C12.0733 13.4828 12.0733 14.7101 12.0733 16.0101C12.2272 15.8465 12.3437 15.7192 12.4601 15.5919C12.7596 15.2647 13.0591 14.9374 13.3627 14.6101C13.6414 14.3146 13.9741 14.301 14.2154 14.5692C14.4608 14.8374 14.4524 15.201 14.1779 15.501C13.4501 16.301 12.7222 17.0965 11.9901 17.8874C11.6283 18.2783 11.3455 18.2647 10.9878 17.8738C10.3098 17.1329 9.62769 16.3919 8.94557 15.6465C8.87902 15.5738 8.80831 15.501 8.75008 15.4192C8.54628 15.1419 8.56707 14.7828 8.79167 14.551C9.02043 14.3192 9.35317 14.3101 9.58609 14.5646C10.0103 15.0237 10.4221 15.4965 10.8422 15.9601C10.8671 15.9465 10.8879 15.9374 10.9129 15.9238H10.9171Z",
    fill: "#303030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3241_265",
    x: 0,
    y: 0,
    width: 23,
    height: 22.1739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3241_265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3241_265",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2d60162a1b507b084173aefda6cdbb60.svg";
export { ForwardRef as ReactComponent };